<template>
<svg viewBox="0 0 17 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Pin`]" width="1em" height="1em" v-bind="$attrs"><path d="M8.66506 15L2.31008 8.64502C0.563307 6.89825 0.563307 4.05685 2.31008 2.31008C4.05685 0.563307 6.89825 0.563307 8.64348 2.31008L15.0293 8.6959C15.6568 9.32338 16.0037 10.159 16.0037 11.047C16.0037 11.9351 15.6583 12.7707 15.0293 13.3997C13.7327 14.6963 11.6221 14.6963 10.3255 13.3997L4.28657 7.36077C3.89189 6.96763 3.67605 6.44344 3.67605 5.88533C3.67605 5.32723 3.89343 4.80459 4.28811 4.4099C4.68125 4.01677 5.20543 3.79938 5.76354 3.79938C6.32164 3.79938 6.84429 4.01677 7.23897 4.4099L13.2332 10.4041L12.1555 11.4818L6.1613 5.48757C5.94854 5.27482 5.57853 5.27482 5.36577 5.48757C5.25939 5.59395 5.20081 5.73579 5.20081 5.88533C5.20081 6.03642 5.25939 6.17672 5.36577 6.2831L11.4047 12.322C12.1077 13.0251 13.2501 13.0251 13.9532 12.322C14.2939 11.9813 14.4804 11.5296 14.4804 11.047C14.4804 10.566 14.2923 10.1127 13.9532 9.77356L7.56735 3.38774C6.41569 2.23607 4.54095 2.23607 3.38774 3.38774C2.23607 4.53941 2.23607 6.41415 3.38774 7.56736L9.74272 13.9223L8.66506 15Z"/></svg>
</template>
<script>

export default {
  name: 'IconPin',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
